/**
 * Data de migração do sistema de extratos
 * 06/08/2025 é o primeiro dia válido para o novo extrato
 * Datas anteriores devem usar o extrato legado
 */
export const EXTRACT_MIGRATION_DATE = "2025-08-06";

export const GET_BANK_ACCOUNTS_DEFAULT_PAGINATION = {
	currentPage: 1,
	perPage: 10000,
};
